import { useEffect, useState } from "react";
import api from "@/api/api.js";

/**
 * Catálogo público de paquetes activos, ya ordenado por el backend.
 *
 * @param {object[]} [initial] catálogo que ya venía en la página (la portada
 *   pre-generada lo trae escrito): se pinta de inmediato y se refresca igual.
 */
export const usePackages = (initial) => {
  const [packages, setPackages] = useState(initial ?? []);
  const [loading, setLoading] = useState(!initial);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    api
      .get("/packages", { headers: { Accept: "application/json" } })
      .then(({ data }) => {
        if (!cancelled) setPackages(data);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { packages, loading, error };
};
